import React from 'react';
import './DownloadToast.css';

interface DownloadToastProps {
  filename: string;
  progress: number;
  onClose?: () => void;
}

const DownloadToast: React.FC<DownloadToastProps> = ({ filename, progress, onClose }) => {
  const isComplete = progress >= 100;

  return (
    <div className={`download-toast ${isComplete ? 'complete' : ''}`}>
      <div className="toast-header">
        <div className="toast-icon">
          {isComplete ? '✓' : '↓'}
        </div>
        <div className="toast-content">
          <div className="toast-title">
            {isComplete ? 'Download Complete' : 'Downloading'}
          </div>
          <div className="toast-filename">{filename}</div>
        </div>
        {onClose && isComplete && (
          <button className="toast-close" onClick={onClose}>
            ✕
          </button>
        )}
      </div>
      <div className="toast-progress-container">
        <div
          className="toast-progress-bar"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="toast-progress-text">{Math.round(progress)}%</div>
    </div>
  );
};

export default DownloadToast;
